<template>
  <div>
    <div class="text-xl font-black py-2">8. Member's Top Tips</div>

    <!-- Sub section-->
    <div class="pt-2">
      <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
        <review-question-component v-model="form.questions[page][sectionStart][index]" container-class="flex justify-between w-full" :showMandatory="showMandatory"></review-question-component>
        <hr class="border-b my-8" />
      </div>
    </div>
    <div class="pt-2">
      <div class="font-black text-lg py-2">Case Studies from the Network</div>
      <div class="flex mb-4">
        <div class="w-full pr-2">
          <div class="py-2">Below are some examples of when a Guild product or service has worked well for a fellow Guild Member</div>
          <div class="w-full p-4 border bg-grey-lighter border-grey">
            <p>James Du Pavey has used Starberry as part of the Premium Plan to improve his Local SEO and has reported a huge increase in leads coming through his website. Combining this with the LeadPro system and dashboard, they claim to have received thousands of leads and increased their revenue as a result.</p>
            <p>Wood & Pilcher use the printed Life magazine, Market Reports and the ‘Moving with the Guild’ brochure as a ‘leave behind pack’ on valuations, as a way of competing with the bigger corporates and differentiating themselves from the other independents as well as enforcing their professionalism and expertise in the industry. </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  }
}
</script>
